import React, { createContext, useContext, useState, useEffect } from 'react';

interface LoadingContextType {
  isThreeReady: boolean;
  setThreeReady: (ready: boolean) => void;
  isLoading: boolean;
}

const LoadingContext = createContext<LoadingContextType>({
  isThreeReady: false,
  setThreeReady: () => { },
  isLoading: true,
});

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isThreeReady, setThreeReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const minTimeValues = new Promise((resolve) => setTimeout(resolve, 2000));
    const maxWaitTime = new Promise((resolve) => setTimeout(resolve, 4000));

    if (isThreeReady) {
      minTimeValues.then(() => {
        setTimeout(() => setIsLoading(false), 500);
      });
    } else {
      maxWaitTime.then(() => {
        if (isLoading) setIsLoading(false);
      });
    }
  }, [isThreeReady, isLoading]);

  return (
    <LoadingContext.Provider value={{ isThreeReady, setThreeReady, isLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
